<template>
  <div class="role-com">
    <tx-bg src="oldclassic_m_roleinfo_beijin" class="center">
      <!-- <div class="role-info-empty"></div> -->
      <TxBg src="oldclassic_m_rank_title" class="mt-110" />
      <search class="rank-search -mt-40" />

      <rank_router :server="server" />

      <basic :new_role="role_info.new_role" />

      <tx-bg
        src="oldclassic_m_roleinfo_img_db"
        class="role-info pt-64 pl-48 pr-36"
      >
        <TxBtn
          src="rank_fanhui"
          class="roleinfo-fanhui"
          name="返回"
          @click="goBack(router)"
        />

        <div class="role-info-title between">
          <div>
            <tx-btn
              :src="
                cur_key == t.key
                  ? 'oldclassic_p_roleinfo_btn_yeqian_dis'
                  : 'oldclassic_p_roleinfo_btn_yeqian_nml'
              "
              :name="t.title"
              class="role-info-title-item"
              :class="{ 'role-info-title-item-act': cur_key == t.key }"
              v-for="t in show_content"
              :key="`title-${t.key}`"
              @click="cur_key = t.key"
            >
              {{ t.title }}
            </tx-btn>
          </div>

          <!-- <div>数据更新时间：{{ role_info.new_role.update_time }}</div> -->
        </div>

        <div class="role-info-content mt-40">
          <component
            v-for="t in show_content"
            v-show="cur_key == t.key"
            :is="t.component"
            :key="t.key"
            :role_data="role_info"
          />
        </div>
      </tx-bg>

      <Link />
    </tx-bg>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

import { get_role } from '@utils/api';
import basic from './components/basic.vue';
import inc_basic_info from './components/inc_basic_info.vue';
import inc_skill from './components/inc_skill.vue';
import inc_holy_beast from './components/inc_holy_beast.vue';
import inc_phantom from './components/inc_phantom.vue';
import inc_child from './components/inc_child.vue';
import inc_final_skill from './components/inc_final_skill.vue';
import inc_hero from './components/inc_hero.vue';
import inc_pic_scroll from './components/inc_pic_scroll.vue';
import Link from './components/link.vue';
import rank_router from './components/rank_router.vue';
import search from './components/search.vue';

import { goBack, goRank } from '@utils/goBack';
import eventEmitter from '@utils/event';

const { group, is_mobile, schools, sectors } = inject('GlobalStore');
const { school_icon } = inject('filters');

const route = useRoute();
const router = useRouter();

const role_info = ref({});

const cur_key = ref('inc_basic_info');

const role_info_com = shallowRef([
  {
    title: '角色信息',
    component: inc_basic_info,
    key: 'inc_basic_info',
  },
  { title: '技能特技', component: inc_skill, key: 'inc_skill' },
  { title: '灵兽', component: inc_holy_beast, key: 'inc_holy_beast', hide: [] },
  // { title: '山海玄魂', component: null, key: '', hide: ['tx3', 'oldclassic'] },
  { title: '元魂珠', component: inc_phantom, key: 'inc_phantom', hide: [] },
  {
    title: '孩子',
    component: inc_child,
    key: 'inc_child',
    hide: ['oldclassic', 'tx2'],
  },
  {
    title: '觉醒',
    component: inc_final_skill,
    key: 'inc_final_skill',
    hide: ['oldclassic'],
  },
  {
    title: '轩辕英魂',
    component: inc_hero,
    key: 'inc_hero',
    hide: ['oldclassic'],
  },
  {
    title: '山河画卷',
    component: inc_pic_scroll,
    key: 'inc_pic_scroll',
    hide: ['oldclassic'],
  },
]);

const show_content = computed(() => {
  return role_info_com.value.filter((t) => !t.hide?.includes(group.value));
});

const query = computed(() => route.query);
onMounted(() => {
  if (!query.value.key) {
    goBack(router);
  }

  get_role({ role_id: query.value.key }).then((res) => {
    if (res.code == 0) {
      role_info.value = res.data;
      console.log('role_info', role_info.value);
      if(res.data.role_id != query.value.key) {
        // 重定向链接
        const url = new URL(window.location.href);
        url.searchParams.set('key', res.data.role_id);
        window.history.replaceState(null, '', url.toString());
      }
    } else if (res.code == 500 && res.errorMsg == '角色不存在') {
      goRank(router);
    } else {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
        duration: 5,
      });
    }
  });
});

const server = computed(() => {
  return role_info.value?.new_role?.server;
});
</script>

